import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IFetchCurrentTermResponse, IFetchProjectVideoDataResponse, IVideoStore } from './interfaces';
import { fetchAccountCurrentTerm, fetchProjectVideoData, fetchProjectVideoUsage } from './thunk';

const initialState: IVideoStore = {
  loading: false,
  allocatedSeconds: 0,
  termStartDate: '',
  totalVideoUsage: 0,
  usageByProjects: []
};

const videoDashboardSlice = createSlice({
  name: 'videoDashboard',
  initialState,
  reducers: {},
  extraReducers: {
    [fetchAccountCurrentTerm.pending.type]: (state) => {
      state.loading = true;
      state.usageByProjects = [];
      state.allocatedSeconds = 0;
      state.totalVideoUsage = 0;
      state.termStartDate = '';
    },
    [fetchAccountCurrentTerm.rejected.type]: (state) => {
      state.loading = false;
    },
    [fetchAccountCurrentTerm.fulfilled.type]: (state, action: PayloadAction<IFetchCurrentTermResponse>) => {
      const { termStartDate, allocatedSeconds } = action.payload;
      state.termStartDate = termStartDate;
      state.allocatedSeconds = allocatedSeconds;
    },
    [fetchProjectVideoUsage.rejected.type]: (state) => {
      state.loading = false;
    },
    [fetchProjectVideoData.rejected.type]: (state) => {
      state.loading = false;
    },
    [fetchProjectVideoData.fulfilled.type]: (state, action: PayloadAction<IFetchProjectVideoDataResponse>) => {
      state.loading = false;
      state.usageByProjects = action.payload;
      state.totalVideoUsage = action.payload.reduce((acc, projectVideoUsage) => {
        return acc + projectVideoUsage.totalVideoUsage;
      }, 0);
    }
  }
});

export const videoDashboardReducer = videoDashboardSlice.reducer;
